import type * as React from "react";
import Link from "next/link";
import { mainNav, siteConfig } from "@/lib/site/navigation";
import Image from "next/image";

export const Header: React.FC = () => {
  return (
    <header className="bg-transparent relative top-0">
      <div className="mx-auto flex h-16 items-center justify-between px-12 sm:px-6 lg:px-8 bg-black">
        <Link
          href="/"
          className="inline-flex h-14"
        >
          {/* <i className="bi bi-car-front-fill text-base" aria-hidden="true" /> */}
          {/* {siteConfig.name} */}
          <Image src="/logo.svg" width={150} height={34} alt={siteConfig.name} />
        </Link>
        {/* <nav aria-label="Main navigation">
          <ul className="flex items-center gap-1 sm:gap-2">
            {mainNav.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className="rounded-full px-3 py-2 text-sm font-medium text-zinc-600 transition-colors hover:bg-zinc-100 hover:text-foreground dark:text-zinc-400 dark:hover:bg-zinc-900 dark:hover:text-zinc-50"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav> */}
      </div>
    </header>
  );
};
